import IconAsMaskImage from '../IconAsMaskImage'

const SearchIcon = ({ pureSvg, className, color }) => {
  const svg = (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.82494 14.5663C11.5481 14.5663 14.5664 11.5481 14.5664 7.82491C14.5664 4.10173 11.5481 1.0835 7.82494 1.0835C4.10176 1.0835 1.08353 4.10173 1.08353 7.82491C1.08353 11.5481 4.10176 14.5663 7.82494 14.5663Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5137 12.8638L15.1568 15.4999"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )

  if (pureSvg) return svg

  return <IconAsMaskImage {...{ svg, className, color }} />
}

export default SearchIcon
